import { getFullUrl } from '@/services/utils/RequestUtils';
import { redirect } from '@/utils/redirect';

export function triggerRedirectToDenizBank(paymentIntentId: string) {
  redirect(getFullUrl(`paymentintent/${paymentIntentId}/denizbank/gethtml`));
}
